import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardLayout from 'src/app/layouts/DashboardLayout';
import MainLayout from 'src/app/layouts/MainLayout';
import LoginView from 'src/app/views/auth/LoginView';
import RegisterView from 'src/app/views/auth/RegisterView';
import NotFoundView from './app/views/errors/NotFoundView';
import DraftPageView from './app/views/errors/DraftPageView';
import MapViewCamera from './app/views/streamCamera';
import PlaybackView from './app/views/playbackVideo/PlaybackVideo';
import DeviceListView from './app/views/device';
import ImageListView from './app/views/image/ImageListView';
import RoutingView from './app/views/RoutingView';
import ManageView from './app/views/manage';
import BaoCaoBGTView from './app/views/baoCaoBGT';
import HanhTrinhChayXeControlView from './app/views/baoCaoBGT/HanhTrinhChayXe';
import BaoCaoDungDoControlView from './app/views/baoCaoBGT/BaoCaoDungDo';
import BaoCaoTongHopTheoLaiXeControlView from './app/views/baoCaoBGT/BaoCaoTongHopTheoLaiXe';
import BaoCaoTongHopTheoXeControlView from './app/views/baoCaoBGT/BaoCaoTongHopTheoXe';
import QuaTocDoGioihanControlView from './app/views/baoCaoBGT/QuaTocDoGioihan';
import ThoiGianLaiXeLienTucControlView from './app/views/baoCaoBGT/ThoiGianLaiXeLienTuc';
import TocDoCuaXeControlView from './app/views/baoCaoBGT/TocDoCuaXe';

import BaoCaoPhuLuc5ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc5';
import BaoCaoPhuLuc8ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc8';
import BaoCaoPhuLuc14ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc14';
import BaoCaoPhuLuc16ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc16';
import BaoCaoPhuLuc17ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc17';
import BaoCaoPhuLuc19ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc19';
import BaoCaoPhuLuc9ControlView from './app/views/baoCaoTT09/BaoCaoPhuLuc9';
import MainBaoCaoDNiew from './app/views/baoCaoDN/mainControl';
import DriverListView from './app/views/manage/driver';
import TrackingView from './app/views/TrackingView';
import MemberManage from './app/views/manage/users';
import VehicleType from './app/views/manage/vehicles/vehicle_types';
import AgenciesManage from './app/views/manage/agency';
import VideoPlaybackList from './app/views/playbackVideo/PlaybackVideo';
import PrivacyPolicy from './app/views/privacyPolicy';
import ServicePackageView from './app/views/manage/ServicePackages';
import StatisticWarehouseTransfer from './app/views/manage/StatisticWarehouseTransfer/StatisticWarehouseTransfer';
import StatisticDeviceActive from './app/views/manage/StatisticDeviceActive/StatisticDeviceActive';
import StatisticServices from './app/views/manage/StatisticServices/StatisticServices';
import MainControlStatistic from './app/views/manage/mainControl/MainControlStatistic';
import ServiceStaff from './app/views/manage/staff';
import BaoCaoHinhAnh from './app/views/baoCaoBGT/BaoCaoHinhAnh/BaoCaoHinhAnh';
import VersionView from './app/views/manage/versions';
import ForbiddenPage from './app/views/errors/ForbiddenPage';
import UserProfileView from './app/views/profile/UserProfile';
import SimView from './app/views/manage/sim';
import AppDownload from './app/views/manage/AppDownload/AppDownload';
import CustomerTable from './app/views/manage/customers';
import FeedbackTable from './app/views/manage/Feedbacks';
import MonitorView from './app/views/manage/monitor/MonitorView';
import SalesOrdersView from './app/views/manage/salesOrders';
import ActionLogsScreen from './app/views/manage/ActionLogs';
import SafeZonesTable from './app/views/manage/SafeZones';
import ActivitySummary from './app/views/baoCaoDN/ActivitySummary/ActivitySummary';
import ActivityDetail from './app/views/baoCaoDN/ActivityDetail/ActivityDetail';
import BaoCaoDoHutNhienLieu from './app/views/baoCaoDN/BaoCaoDoHutNhienLieu/BaoCaoDoHutNhienLieu';
import FuelReport from './app/views/baoCaoDN/FuelReport/FuelReport';
import FuelConsumption from './app/views/baoCaoDN/FuelConsumption/FuelConsumption';
import MonitoringArea from './app/views/baoCaoDN/MonitoringArea/MonitoringArea';
import DriverAccounts from './app/views/manage/DriverAccounts.js';
const AppFallback = () => {
  const { isAccountant, isSale, isAdmin, isAgency, isStaff, isTechnician, dataLogin } = useSelector(state => state.authSlice);
  const token = localStorage.getItem('access-token');

  if (token && !dataLogin) {
    return null;
  }

  if (isAccountant || isSale) {
    return <Navigate to="/app/manage/sales-orders" replace />;
  }
  if (isTechnician) {
    return <Navigate to="/app/manage/devices" replace />;
  }
  return <Navigate to="/app/tracking" replace />;
};
const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <UserProfileView /> },
      { path: 'tracking', element: <TrackingView /> },
      { path: 'routing', element: <RoutingView /> },
      { path: 'camera', element: <ImageListView /> },
      {
        path: 'video',
        element: <MonitorView />,
        children: [
          {
            path: 'streaming',
            element: <MapViewCamera />
          },
          {
            path: 'playback',
            element: <VideoPlaybackList />
          }
        ]
      },
      { path: 'playback', element: <PlaybackView /> },

      //manage
      {
        path: 'manage',
        element: <ManageView />,
        children: [
          {
            path: 'statistics',
            element: <MainControlStatistic />,
            children: [
              {
                path: 'warehouse-transfer',
                element: <StatisticWarehouseTransfer />
              },
              // {
              //   path: 'active',
              //   element: <StatisticDeviceActive/>
              // },
              {
                path: 'service',
                element: <StatisticServices />
              }
            ]
          },
          {
            path: 'users',
            element: <MemberManage />
          },
          {
            path: 'customers',
            element: <CustomerTable />
          },
          {
            path: 'agencies',
            element: <AgenciesManage />
          },
          {
            path: 'service-staffs',
            element: <ServiceStaff />
          },
          {
            path: 'service-packages',
            element: <ServicePackageView />
          },
          {
            path: 'vehicle-types',
            element: <VehicleType />
          },
          {
            path: 'devices',
            element: <DeviceListView />
          },
          {
            path: 'versions',
            element: <VersionView />
          },
          {
            path: 'sim',
            element: <SimView />
          },
          {
            path: 'broadcasts-schedules',
            element: <ManageView />
          },
          {
            path: 'files-audio',
            element: <ManageView />
          },
          {
            path: 'files-video',
            element: <ManageView />
          },
          {
            path: 'images',
            element: <ManageView />
          },

          {
            path: 'driver',
            element: <DriverListView />
          },
          {
            path: 'accounts-driver',
            element: <DriverAccounts />
          },
          {
            path: 'feedbacks',
            element: <FeedbackTable />
          },
          {
            path: 'sales-orders',
            element: <SalesOrdersView />
          },
          {
            path: 'action-logs',
            element: <ActionLogsScreen />
          },
          {
            path: 'safe-zone',
            element: <SafeZonesTable />
          }
        ]
      },

      //reports BGT
      {
        path: 'baocao-bgt',
        element: <BaoCaoBGTView />,
        children: [
          {
            path: 'tt073',
            children: [
              {
                path: 'hanh-trinh-chay-xe',
                element: <HanhTrinhChayXeControlView />
              },
              {
                path: 'bao-cao-dung-do',
                element: <BaoCaoDungDoControlView />
              },

              {
                path: 'bao-cao-tong-hop-theo-lai-xe',
                element: <BaoCaoTongHopTheoLaiXeControlView />
              },

              {
                path: 'bao-cao-tong-hop-theo-xe',
                element: <BaoCaoTongHopTheoXeControlView />
              },

              {
                path: 'qua-toc-do-gioi-han',
                element: <QuaTocDoGioihanControlView />
              },

              {
                path: 'thoi-gian-lai-xe-lien-tuc',
                element: <ThoiGianLaiXeLienTucControlView />
              },

              {
                path: 'toc-do-cua-xe',
                element: <TocDoCuaXeControlView />
              },
              {
                path: 'bao-cao-hinh-anh',
                element: <BaoCaoHinhAnh />
              }
            ]
          },

          {
            path: 'tt09',
            children: [
              { path: 'tt09-phu-luc-5', element: <BaoCaoPhuLuc5ControlView /> },
              { path: 'tt09-phu-luc-8', element: <BaoCaoPhuLuc8ControlView /> },
              {
                path: 'tt09-phu-luc-14',
                element: <BaoCaoPhuLuc14ControlView />
              },
              {
                path: 'tt09-phu-luc-16',
                element: <BaoCaoPhuLuc16ControlView />
              },
              {
                path: 'tt09-phu-luc-17',
                element: <BaoCaoPhuLuc17ControlView />
              },
              { path: 'tt09-phu-luc-9', element: <BaoCaoPhuLuc9ControlView /> },
              {
                path: 'tt09-phu-luc-19',
                element: <BaoCaoPhuLuc19ControlView />
              }
            ]
          }
        ]
      },

      {
        path: 'baocao-dn',
        element: <BaoCaoBGTView />,
        children: [
          {
            path: 'bao-cao-ve-tong-hop-hoat-dong-theo-nhom',
            element: <ActivitySummary />
          },
          {
            path: 'bao-cao-tong-hop-hoat-dong'
          },
          {
            path: 'bao-cao-chi-tiet-hoat-dong',
            element: <ActivityDetail />
          },
          {
            path: 'bao-cao-tong-hop-nhien-lieu',
            element: <FuelReport />
          },
          {
            path: 'bao-cao-tieu-hao-nhien-lieu',
            element: <FuelConsumption />
          },
          {
            path: 'bao-cao-vao-ra-vung-giam-sat',
            element: <MonitoringArea />
          },
          {
            path: 'bao-cao-lich-hen'
          },
          {
            path: 'bao-cao-tong-hop-km-xe-hoat-dong'
          },
          {
            path: 'bao-cao-tong-hop-bat-dieu-hoa'
          },
          {
            path: 'bao-cao-dung-do'
          },
          {
            path: 'bao-cao-do-hut-nhien-lieu',
            element: <BaoCaoDoHutNhienLieu />
          },
          {
            path: 'bao-cao-ra-vao-tram'
          },
          {
            path: 'bao-cao-chuyen-kinh-doanh'
          },
          {
            path: 'bao-cao-bat-dieu-hoa'
          },
          {
            path: 'bao-cao-thu-phi-duong-bo'
          },
          {
            path: 'bao-cao-cuoc-qua-diem-thu-phi'
          },
          {
            path: 'bao-cao-hoat-dong-thang'
          },
          {
            path: 'bao-cao-hoat-hanh-trinh'
          },
          {
            path: 'bao-cao-mo-cua'
          },
          {
            path: 'bao-cao-nang-ha-ben'
          },
          {
            path: 'bao-cao-nang-ha-cau'
          },
          {
            path: 'bao-cao-dong-co'
          },
          {
            path: 'bao-cao-trang-thai-dong-co'
          },
          {
            path: 'bao-cao-loi-xung'
          },
          {
            path: 'bao-cao-mat-tin-hieu'
          }
        ]
      },

      { path: '*', element: <AppFallback /> }
    ]
  },

  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
      { path: 'app-download', element: <AppDownload /> },
      { path: 'login', element: <LoginView /> },
      { path: 'register', element: <RegisterView /> },
      { path: '404', element: <NotFoundView /> },
      { path: 'waiting-confirm', element: <DraftPageView /> },
      { path: '/', element: <AppFallback /> },
      { path: '*', element: <Navigate to="/404" /> },
      { path: '/403', element: <ForbiddenPage /> }
    ]
  }
];

export default routes;
